import { ReportsStatisticsResponse } from './model/ReportsStatisticsResponse';

export const useReportGraphLabels = (data: ReportsStatisticsResponse[]): string[] => {
  const labels = data.map((dataset) => dataset.locationUId);

  return labels;
};
